import React, { Component } from "react";

import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";
import ToGIFWorkContentVideoFunction from "./children/ToGIFWorkContentVideo/ToGIFWorkContentVideoFunction";
import ToGIFWorkContentWorkFunction from "./children/ToGIFWorkContentWork/ToGIFWorkContentWorkFunction";
import ToGIFWorkFooterRender from "./children/ToGIFWorkFooterRender";

import "@/assets/toGIF.less";

class ToGIFWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="content">
          <CloseIcon className="close-file" onClick={() => this.props.handleCloseFile(null)} />
          <ToGIFWorkContentVideoFunction toGifObj={this.props.toGifObj} onToGifObjChange={this.props.onToGifObjChange} />
          <ToGIFWorkContentWorkFunction toGifObj={this.props.toGifObj} onToGifObjChange={this.props.onToGifObjChange} />
        </div>
        <ToGIFWorkFooterRender preSubmit={this.props.preSubmit} />
      </div>
    );
  }
}

export default ToGIFWorkFunction;
